var PerfilForm = function () {

    this.init = function () {

        jQuery.validator.addMethod("newPassword", function(value, element) {
            return !$(element).is(":visible") || value.length >= 5;
        }, "Preencha a nova senha.");

        $('[data-component="perfil-form"] .scrollbar-inner').scrollbar();
        $('.btn-nova-senha').click(function(e){
            e.preventDefault();
            $('.nova-senha').css("display", "block");


        });

        $('.btn-logout').click(function(e){
			var obj = $(this);
			
            console.log("Logout");
		
				$('.submenu-perfil').slideUp();
			
				$('.tooltip-modal').slideUp();
            e.preventDefault();
            $.ajax({
                type: "POST",
                url: "/umbraco/surface/members/logout",
                async: true,
                contentType: "application/json; charset=utf-8",
                success: function success(response) {

                    if(response == true){
                        $('#modal-header').find('#isMemberLogged').val("false");
                        
							$('.submenu-perfil').slideUp();
							$('.tooltip-modal').slideUp();
						
                    }else{
                        $("#perfil-form").find(".error").text("Ocorreu um erro, tente novamente mais tarde.");
                    }

                },
                error: function error(e) {
                    $("#perfil-form").find(".error").text("Ocorreu um erro, tente novamente mais tarde.");
                },
                complete: function () {

                }
            });
        });

        $('#perfilFormValidate').validate({
            ignore: '.ignore',
            errorPlacement: function (error, element) {
                console.log(error);
                return true;
            },
            rules: {
                nome: {
                    required: true,
                },
                empresa: {
                    required: true,
                },
                segmento: {
                    required: true,
                },
                funcionarios: {
                    required: true,
                },  
                email: {
                    required: true,
                    email: true
                },
                password:{
                    minlength: 5
                },
                new_password:{
                    newPassword: true
                }

            },
            submitHandler: function (form) {

                var submittedForm = $(form);
                var componentID = parseInt(submittedForm.data("id"));

                submittedForm.find("button[type='submit']").attr("disabled", true);

                var perfilData = {
                    "Email": submittedForm.find("input[name='email']").val(),
                    "NewPassword": submittedForm.find("input[name='new_password']").val(),
                    "Name": submittedForm.find("input[name='nome']").val(),
                    "Company": submittedForm.find("input[name='empresa']").val(),
                    "Segment": submittedForm.find("select[name='segmento']").val(),
                    "NumberOfEmployees": submittedForm.find("select[name='funcionarios']").val()
                };

                $.ajax({
                    type: "POST",
                    url: "/umbraco/surface/members/update",
                    data: JSON.stringify( perfilData ),
                    dataType: "json",
                    async: true,
                    contentType: "application/json; charset=utf-8",
                    success: function success(response) {
                        
                        
                        if(response == true){
                            $("#perfilDataValidate").each(function () {
                                this.reset();
                            });
                            $("#perfil-form").css("display", "none");
                        	$("#perfil-confirmacao").css("display", "block");
                        }else if(responde == false){
                            $("#perfil-form").find(".error").text("Ocorreu um erro, tente novamente mais tarde.");
                        }else if(response.length > 0){
                            $("#perfil-form").find(".error").text(response);
                        }

                    },
                    error: function error(e) {
                        $("#perfil-form").find(".error").text("Ocorreu um erro, tente novamente mais tarde.");
                    },
                    complete: function () {

                        submittedForm.find("button[type='submit']").attr("disabled", false);
                    }
                });
            }
        });
    }

    return this.init();
}